var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.94922C4.1402 1.94922 1 5.08942 1 8.94922C1 12.809 4.1402 15.9492 8 15.9492C11.8598 15.9492 15 12.809 15 8.94922C15 5.08942 11.8598 1.94922 8 1.94922ZM8 14.5492C4.9123 14.5492 2.4 12.0369 2.4 8.94922C2.4 5.86152 4.9123 3.34922 8 3.34922C11.0877 3.34922 13.6 5.86152 13.6 8.94922C13.6 12.0369 11.0877 14.5492 8 14.5492Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6996 5.79902C8.6996 5.32969 8.31913 4.94922 7.8498 4.94922C7.38047 4.94922 7 5.32969 7 5.79902V9.30181L9.23087 11.4123C9.54926 11.7135 10.0475 11.7135 10.3659 11.4123C10.7103 11.0865 10.7103 10.5383 10.3659 10.2125L8.6996 8.63614V5.79902Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDefault);
export default __webpack_public_path__ + "static/media/time-default.20bf16e2a41fe9d9317d063b385bd53b.svg";
export { ForwardRef as ReactComponent };